// extracted by mini-css-extract-plugin
module.exports = {"accounts":"Accounts_accounts__C4Toh","accountIcon":"Accounts_accountIcon__mv4a0","userDetails":"Accounts_userDetails__198rf"};